import { HistoryActionEnum } from 'core/global.enum';

export type HistoryActionAutocompleteProps = {
  selectedAction: HistoryActionEnum | undefined;
  onChangeAction: (action: HistoryActionEnum) => void;
  historyType:
    | 'cards'
    | 'owners'
    | 'groups'
    | 'groupPermissions'
    | 'ownersEffectivePermissions'
    | 'control'
    | 'wanted'
    | 'announcements'
    | 'schedules'
    | 'sequences'
    | 'usersLogin'
    | 'user';
};

export enum HistoryActionDescriptionEnum {
  ZABLOKOWANO = 'history.status.blocked',
  ODBLOKOWANO = 'history.status.unblocked',
  ZWROCONO = 'history.status.returned',
  WYDANO = 'history.status.issued',
  ZARCHIWIZOWANO = 'history.status.archived',
  PRZYWROCONO = 'history.status.restored',
  DODANO = 'history.status.added',
  ZEDYTOWANO = 'history.status.edited',
  USUNIETO = 'history.status.removed',
  ZALOGOWANO = 'history.status.logged',
  WYLOGOWANO = 'history.status.logout',
}
